// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React, { useState, useEffect } from 'react';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useTheme } from '@mui/system';
import stylesDef from './styles';

interface OrthomosaicCheckboxProps {
  onMasterToggle?: (allVisible: boolean) => void;
  disabled?: boolean;
}

const OrthomosaicCheckbox: React.FC<OrthomosaicCheckboxProps> = ({ onMasterToggle, disabled = false }) => {
  const theme = useTheme();
  const styles = stylesDef(theme);

  // Local visibility state (no Redux)
  const [visible, setVisible] = useState(true);

  // Check if any layer is visible
  useEffect(() => {
    const checkLayersState = () => {
      const rasterLayers = (window as any).rasterLayers as Array<{ layer: any }>;
      if (rasterLayers && rasterLayers.length) {
        const anyVisible = rasterLayers.some(r => r.layer?.visible);
        setVisible(anyVisible);
      }
    };

    // Initial check
    checkLayersState();

    // Set up periodic check to stay in sync with individual toggles
    const interval = setInterval(checkLayersState, 300);

    return () => clearInterval(interval);
  }, []);

  const handleChange = () => {
    if (disabled) return;
    const newVisible = !visible;
    setVisible(newVisible);

    // Toggle all raster layers in Esri map directly
    const rasterLayers = (window as any).rasterLayers as Array<{ layer: any }>;
    if (rasterLayers && rasterLayers.length) {
      rasterLayers.forEach((r) => {
        if (r.layer) r.layer.visible = newVisible;
      });
    }
    if (onMasterToggle) {
      onMasterToggle(newVisible);
    }
  };

  return (
    <FormControlLabel
      control={
        <Checkbox
          color="primary"
          checked={disabled ? false : visible}
          onChange={handleChange}
          sx={styles.checkbox}
          disabled={disabled}
        />
      }
      label={<Typography variant="h5" sx={styles.sidebarHeader}>Orthomosaic</Typography>}
      onClick={(e) => e.stopPropagation()}
    />
  );
};

export default OrthomosaicCheckbox;
